(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["p3-media-grid"] && !Shopify.designMode) return;
  try {
    (function() {
    var GAP = 8;
    function checkMediaGridTagsOverflow() {
      var containers = document.querySelectorAll('[data-p3-media-grid-tags]');
      containers.forEach(function(container) {
        if (container.classList.contains('is-expanded')) return;
        var inner = container.querySelector('.p3-media-grid-item__tags-inner');
        if (!inner) return;
        var w = inner.clientWidth;
        var scrollW = inner.scrollWidth;
        var overflowing = scrollW > w;
        var nearFull = w > 0 && (scrollW >= w * 0.8);

        var tags = [].slice.call(inner.children).filter(function(el) {
          return el.classList && el.classList.contains('p3-media-grid-item__tag');
        });
        var pill = inner.querySelector('.p3-media-grid-item__tags-more');
        tags.forEach(function(tag) {
          tag.classList.remove('p3-media-grid-item__tag--boundary', 'p3-media-grid-item__tag--after-boundary');
        });
        container.classList.toggle('has-no-tags', tags.length === 0);
        var hasHiddenTags = false;
        if ((nearFull || overflowing) && tags.length > 0) {
          // Reserve room for a two-digit "+N" before knowing N.
          var pillWidth = Math.max(pill ? pill.offsetWidth : 0, 44);
          var maxWidth = w * 0.8 - pillWidth - GAP;
          var accumulated = 0;
          var boundaryIndex = -1;
          for (var i = 0; i < tags.length; i++) {
            var tagWidth = tags[i].offsetWidth;
            if (accumulated + tagWidth > maxWidth) {
              boundaryIndex = i;
              break;
            }
            accumulated += tagWidth + GAP;
          }
          if (boundaryIndex < 0) boundaryIndex = tags.length - 1;
          if (boundaryIndex >= 0 && boundaryIndex < tags.length) {
            tags[boundaryIndex].classList.add('p3-media-grid-item__tag--boundary');
            for (var j = boundaryIndex + 1; j < tags.length; j++) {
              tags[j].classList.add('p3-media-grid-item__tag--after-boundary');
            }
            hasHiddenTags = boundaryIndex < tags.length - 1;
            // "+N" says how many services are folded away; "..." did not (PMNS-145)
            if (pill && hasHiddenTags) pill.textContent = '+' + (tags.length - 1 - boundaryIndex);
          }
        }
        container.classList.toggle('has-hidden-tags', hasHiddenTags);
        if (pill) {
          pill.setAttribute('aria-expanded', 'false');
          pill.setAttribute('aria-label', 'Show all services');
        }
      });
    }
    function setupScrollBar(section) {
      var grid = section.querySelector('[data-p3-media-grid-scroll]');
      var progress = section.querySelector('[data-p3-media-grid-scroll-bar]');
      var thumb = section.querySelector('[data-p3-media-grid-scroll-thumb]');
      if (!grid || !progress || !thumb) return;
      function update() {
        var maxScroll = grid.scrollWidth - grid.clientWidth;

        if (maxScroll <= 0) {
          thumb.style.width = '100%';
          return;
        }

        // The last card snaps by its end (see the stylesheet), so the row does
        // reach maxScroll and the bar fills completely. The 4px tolerance covers
        // fractional scroll positions (PMNS-106).
        var atEnd = maxScroll - grid.scrollLeft <= 4;
        var ratio = atEnd ? 1 : Math.min(1, Math.max(0, grid.scrollLeft / maxScroll));

        // Progress bar fill from left to right
        var progressPercent = ratio * 100;

        // Optional: keep small visible start like Figma
        var minPercent = 10;

        thumb.style.width = Math.max(minPercent, progressPercent) + '%';
      }
      // iOS does not fire scroll events reliably through the momentum and the
      // snap settle, so the bar kept the last value it saw and stopped short of
      // the end. Re-read the position once the gesture is over (PMNS-106).
      function settle() {
        [0, 80, 200, 400, 700].forEach(function (ms) { window.setTimeout(update, ms); });
      }
      grid.addEventListener('scroll', update, { passive: true });
      ['touchend', 'touchcancel', 'scrollend'].forEach(function (name) {
        grid.addEventListener(name, settle, { passive: true });
      });
      window.addEventListener('resize', update);
      update();
    }
    function setupHoverVideo(item) {
      if (item._p3HoverVideoBound) return;
      var video = item.querySelector('.p3-media-grid-item__video');
      if (!video) return;
      item._p3HoverVideoBound = true;
      video.muted = true;
      video.pause();
      function play() {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function() {});
      }
      function reset() {
        video.pause();
        try { video.currentTime = 0; } catch (e) {}
      }
      item.addEventListener('pointerenter', function(e) {
        if (e.pointerType === 'mouse') play();
      });
      item.addEventListener('pointerleave', function(e) {
        if (e.pointerType === 'mouse') reset();
      });
    }
    // Desktop: the "+N" pill expands the full list of services and turns into
    // "-", which folds it again. The list stays open until then: folding it as
    // soon as the pointer left the tile made the extra services unreadable
    // (PMNS-145). A width change (resize handler below) still resets it.
    function setupTagsExpand(item) {
      if (item._p3TagsExpandBound) return;
      item._p3TagsExpandBound = true;
      var container = item.querySelector('[data-p3-media-grid-tags]');
      var pill = item.querySelector('.p3-media-grid-item__tags-more');
      if (!container || !pill) return;
      function toggle(e) {
        e.preventDefault();
        e.stopPropagation();
        if (container.classList.contains('is-expanded')) {
          container.classList.remove('is-expanded');
          checkMediaGridTagsOverflow(); // restores "+N" and the folded layout
          return;
        }
        container.classList.add('is-expanded');
        pill.textContent = '−';
        pill.setAttribute('aria-expanded', 'true');
        pill.setAttribute('aria-label', 'Show fewer services');
      }
      pill.addEventListener('click', toggle);
      pill.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') toggle(e);
      });
    }
    function run() {
      checkMediaGridTagsOverflow();
      document.querySelectorAll('.p3-media-grid-item').forEach(setupTagsExpand);
      document.querySelectorAll('.p3-media-grid-section').forEach(setupScrollBar);
      document.querySelectorAll('.p3-media-grid-item').forEach(setupHoverVideo);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    requestAnimationFrame(run);
    setTimeout(run, 300);
    // Width changes only: iOS fires resize while its toolbar collapses on
    // every downward scroll, and re-measuring every tile then costs frames.
    var lastTagsWidth = window.innerWidth;
    window.addEventListener('resize', function() {
      if (window.innerWidth === lastTagsWidth) return;
      lastTagsWidth = window.innerWidth;
      clearTimeout(window._p3MediaGridTagsResize);
      window._p3MediaGridTagsResize = setTimeout(function() {
        document.querySelectorAll('[data-p3-media-grid-tags].is-expanded').forEach(function(c) { c.classList.remove('is-expanded'); });
        checkMediaGridTagsOverflow();
      }, 100);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
